import React , { Component } from 'react';
import Menu from './menu';
import Footer from './footer';
import './App.css';
import {Container,Row,Col,CardBody,CardTitle,CardImg,CardSubtitle,Button,CardText} from 'reactstrap';
import prd_web from './img/prd_web.png';import prd_win from './img/prd_win.png';
import prd_mob from './img/prd_mob.jpg';import product from './img/product.png';

export default class Productskami extends Component {
  render() {
    return (
      <div>
      <Menu />        
      <Container>
        <Row className="judul-product text-left">          
          <Col sm="4">
            <CardImg src={product} style={{height:"contain"}}/>
          </Col>
          <Col sm="8" align="right">
            <h1><b>LOOK</b>, AND DO IT</h1><br/>
            <div className="line" style={{width:"50%"}}/>
            <h4>We provide better results for clients,<br/>through developing IT innovations.</h4>
          </Col>
        </Row>
        <Row>
          <Col sm="12">
          <Products/>
          </Col>
        </Row><br/>
        <Row>
          <Col sm="12">
         
          </Col>
        </Row>
      </Container>
      <Footer/>      
      </div>
      );
    }
}
class Products extends Component {
  render() {
      return (
      <div>
        <section id="products" className="noimage">
              <Container>
                 <Row className="text-center">
                     <Col sm="12">
                       <h2>Our Products</h2> <hr/>    
                     </Col>
                 </Row>
                <Row  className="product-desc">
                    <Col sm="4"> 
                      <CardImg src={prd_win} alt="Card image cap" />
                    </Col>
                    <Col sm="8">
                        <CardBody>
                          <CardTitle>Accmis</CardTitle>
                          <CardSubtitle>Windows Aplication</CardSubtitle>
                          <CardText>kepanjangan dari Accounting Management system, 
                                    ditujukan kepada perusahaan pada bidang accounting.
                                    dengan adannya aplikasi ini diharapkan pengguna lebih
                                    efesien dan cepat dalam penghitungan.
                          </CardText>                          
                        </CardBody>
                    </Col>
                </Row>
                <Row  className="product-desc">
                    <Col sm="8">                                               
                        <CardBody align="right">
                          <CardTitle>Emtor</CardTitle>
                          <CardSubtitle>Mobile Aplication</CardSubtitle>
                          <CardText>Emtor adalah singkatan dari Employer Controler,
                                    ditujukan untuk memonitoring jadwal kerja, absen, 
                                    kemajuan teknik, dan kenyamanan karyawan pada perusahaan 
                                    tersebut.
                          </CardText>                          
                        </CardBody>   
                    </Col>
                    <Col sm="4">
                    <CardImg src={prd_mob} alt="Card image cap" />
                    </Col>
                </Row>
                <Row  className="product-desc">
                    <Col sm="4">
                      <CardImg src={prd_web} alt="Card image cap" />
                    </Col>
                    <Col sm="8">                          
                        <CardBody>
                          <CardTitle>Website</CardTitle>
                          <CardSubtitle>Web Aplication</CardSubtitle>
                          <CardText>Web ini berpengaruh pada pendapatan lokal dan eksternal,
                                    didalamnya kaya akan fitur managing sistem mulai dari
                                    skala kecil hingga skala besar. database yang diyakini
                                    memiliki keamanan tingkat profesional.
                          </CardText>                          
                        </CardBody> 
                    </Col>
                </Row>
              </Container><br/>
          </section>
     </div>
   );
}
}


// WEBPACK FOOTER //
// ./src/products.js